interface BannerDraftState {
  /** Value to send to the API; null removes the banner. */
  nextBanner: string | null
  /** Save is allowed only when nothing is uploading and the value actually changed. */
  canSave: boolean
}

/**
 * Resolves the save payload and button state from the stored banner and the dialog draft.
 */
export function resolveBannerDraft(
  initialBanner: string | null | undefined,
  draft: string,
  uploading: boolean,
): BannerDraftState {
  const initial = (initialBanner ?? '').trim()
  const current = draft.trim()
  return {
    // * VI: Rỗng nghĩa là xoá banner (gửi null), khớp quy ước của master-service | EN: Empty means remove the banner (send null), matching master-service
    nextBanner: current || null,
    canSave: !uploading && current !== initial,
  }
}
